//Function to sort with
//eg array.sort(predicateBy("age"));
export function predicateBy(prop) {
  return function(a, b) {
    if (a[prop] > b[prop]) {
      return 1;
    } else if (a[prop] < b[prop]) {
      return -1;
    }
    return 0;
  };
}
